import React from "react";

const Navbar = () => {
  const register = (e)=>{
    e.preventDefault()
    let data = new FormData(e.currentTarget)
    let adata ={
      name:data.get("name"),
      mobile:data.get("mobile"),
      email:data.get("email"),
      password:data.get("password"),
      city:data.get("city")
    }
    console.log(adata)
  }
  const signin = (e)=>{
    e.preventDefault()
    let data = new FormData(e.currentTarget)
    let adata ={
      email:data.get("email"),
      password:data.get("password"),
    }
    console.log(adata)
  }
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar navbar-light sticky-top"  >
        <div className="container-fluid">
          <a className="navbar-brand bg-white p-1" href="#">
            <div className="d-flex">
              <div>
                <img width={"80px"} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPsAAADJCAMAAADSHrQyAAAAkFBMVEX///8jHyAAAAANAwahoKAYEhRwbm8UDhAgHB0cFxgHAAAZFBWDgoIeGRrr6+v39/fz8/NKRkfCwcE8OTp+fH3l5eWZmJgqJievrq63trfHx8fY2Ng6Nzjg4OBnZWYLAAOLiYpVUlMyLi9aV1ienZ1samtDQEFNSkvZ2dmSkZHFxcWGhYXQz8+ysbFZV1i8uru1AuYIAAAH+ElEQVR4nO2b6XaqMBCAy7AEgiwqIKJsarFare//djeJGyi0t22wt/fM96P1IJBMZsnMgE9PCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIg/wVumO5G030c7w/JS+p6Pz2fxxBuNaMcKwQAKIf9B2sxzKJD+tNT6xM3iZZMZlW3HFOpY5qOrbK1WEY7/6cn2QezqDRBtZtCNzHZAkyy2P3pqcplVjC5rffkvspPYaiFPz1hacRDIBe5HZuocEdOao7g5HkZ/w/hz48oOCedEgqkWgbRIZldYrvvprPkoBXG21zEguMCWBSM3c9O/PtEChXSOEywSRDP3ollnp8eVsaExTzCF0uHSvvNyo+JkNwkMA5GfxnCvVkcDAkw+Z0cgt+68e2GYArBlc3LJy91t5sKgFiEZp+99F/gZcn93Mzt4IuO621fK6AqvP026V8MsJnkVF19a7sOtZLtAs+/aMv3RiXozM/ziSbhZtOMwub793kISbAAi+9TUEjKUP14qPzrO54fHjZrOCUyVikzRoevEkxIFtt4uk2SHSdJRvtVYWSVwkPzOTlVJG9P/j9T5iRA6zkpVYluN6szEzb/zGzlsoOP6xJVif5P6TO7rmPH1glHbxRrpnrMytPR7OutGc/zfZb075LDPtaiYjAIDCNbluthNZ4vFvNxNVy/ZcZgs4qnSeg/JAtOjoo3WeoFoFeZ8VoUxcAoF8Cd/rICOow3M7bpBfPxm1Gs9tvdbpaGrnszSS6gG4bpy4zHj9FUSBkYz1k5HC9Ek4c7Vq6qYoFt27Ysh2Ga/K9l8ZVXczYRdZ4Vo/6zAVFxqcr6dTprypGOirUNF7NgVYwySLwnN35eNGXgYuj66RNR1TynpyBCqThD122LC/ixe11gJTLQSutZfINJp2odDu1OMwDinG2fQL7c7Pwnf7cyxlw2Xq4zoS58Qrq/WQCaG722PzZEUWjc/T238/wqv0VAXQT7GV+YZF9k6/nEpsIGLhZQM4JW+An20eDPJs9s/hRp7EYTkK120KPrR+r7snPS6aDiWj75v6lTZpBGlIit33PTl2QarzbF6yBgAYwTMAZt8C/4Cc/PWZYtl+Ul1q0zg18RGEueXkCunxdbnSS9yV4wvcP2L07c7YNyQbidC804OvtsL5ZFnISyVRNuY2NM4Nj8cSCSfPsLbxazrL+NKV64izfG2jymQdxodZVb/JwFf200S2XmAeHBUEVBoYAh8bY1PLbH6Vn7V93q9NJkqg2ycryYiM3xAplUWRBp8WEnZR2mpZAe2if4XbSc3frWo3i/6W0daLuPjZmlK2wz5zu5toqizSaKVlq8H7Ht/5OeECbxpihWt3VesuZNI9qH8D4rVuyyeWifMZv+apfma7gRc2+wgkPLgmkqC3swkD9oQBTTrHt78kwhp/flixfP5I9+wg9AtaA6dHz9orAUBLq+/TIhz2gn6+GFBQuutGwLfTvHKfpJs6Y2YWnDO9usO7ZZPJa9mWxUsYtcYb5VbyyxhP3y2WMpXh89p4I5tD6/dgl8965g8ieWohaSx60c5RY4K+AlWk9MR1ksL1l1AHQsPccMmOnZ1WmJvYMxZqqYVEEz/Ka6aVpyrc69f654Fj0p+VNHDktZjZNWAmoRyTEwAt4bOorlRTroojzghVOjuXUAhcrtdqV3nYv8GE89A6zaUUJPxl7aDpUa80QJDcf1TCZ5PZWHeb2h/0ycscyBz8X7FWsojocLcmsOS+GDrmM6tkSz93iAIYH4vIIbB7Rgfz2TmShI9bfRrewglto1beUW9ZgExKDYc3kTeFV5ZSQsPrrvnpkwvZ4aqR9VXJ9jezMeEYmzN74XnXnDMakeO2e/kIDYYo9qP7Q1Dk24RhdPJVLT+tnNgFTEtEHeMg1mE0IJU7j45/cJyNnWfL217+FMricXtJI0rCCljZHspTjY0bo1Tf6ttzAVR5LV+3z4YwgzbgPMWRvX+jWEicwy0Z80Vpvu35vGqcPBdVUPQt9A47KTgn0K8452lzm55jlvcoPduhFagQcdn3R13aw1v4THR0mKX4v6dPR0bB61Uwt3MUh9ih3UdWxa/FBr0KmtjSt2ZBmVhbiTovIYU1pdY+rXABdKizOCxiZ3dPeiy+TPOuB2ccoDvkfMTd7kTux1r7epXi+wRxJGvdAYlLzyQ8tOFSjqip8gagBifJ9KtP14qOsKr2LBrw5vyK1js/qTyIIfmd+XN22Lo3+fYyeSB5G7/LIu+zXAxVL1/uS5NfyPZA+ussvCKj+S/VrdzvrrVh9Zd4tGREUzBlUiwPV+m2M1ZL9u6m7fb6oF3bHuuMFrUlnxe/rvyV6bW99PZ2PaPY3eWnbdjmaVH18tje6YW8+xJNNtbPmqrzHb6MwzRPbZD92vf9CHvoc+7ZqH3HS6SdWx4Ppzf2O2MWwr35n1vfY4Zpfi4cGvYqbQVs1Yi16jbNAaYuGh3s5pK2cc0vPmWraEO9rTA9j3iO80b+d9P5/z1nea7+nx6wckSkMLJlQPCLdBs1Fr/dSbx35wecXGtGh/bz40GC3g/OMzU4fhz712HG7GKvCXxez1437vMsr472zYoAuj77rlA8LdPp7OHrvL+Okojkfpb/51EYIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIg/z9/AMHlgzpiagSYAAAAAElFTkSuQmCC" alt="" />
              </div>
              <div>
                <span style={{textDecoration:"bold"}}>CAR</span> <br /> <span style={{fontSize:"14px"}}>Rental</span>
              </div>
          
            </div>
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse d-flex justify-content-center" id="navbarNavDropdown">
            <ul className="navbar-nav">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="#">
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#">
                  About
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#models">
                  Vehicle Models
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#footer">
                  Contact
                </a>
              </li>
             
              
            </ul>
          </div>
          <div className="d-flex justify-content-end">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <button className="nav-link btn" data-bs-toggle="modal" data-bs-target="#signinmodal">
                      Sign In
                    </button>
                </li>
                  <li className="nav-item">
                    <button className="nav-link btn" data-bs-toggle="modal" data-bs-target="#registermodal" style={{backgroundColor:"red"}} >
                      Register
                    </button>
                </li>
                </ul>
              </div>
        </div>
      </nav>

      {/* registermodal */}
      <div className="modal fade" id="registermodal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">
              Registeration Form 
              </h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form onSubmit={register}>
          <div className="modal-body">
            <input type="text" name="name" required placeholder="name" />  
            <input type="number" name="mobile" required  placeholder="mobile no" />  
            <input type="email" name="email" required  placeholder="email"/>  
            <input type="password" name="password" required placeholder="password"  />  
            <input type="text" name="city" required  placeholder="city" />  
            
          </div>
          <div className="modal-footer">
            <button type="submit" className="btn btn-danger">Register</button>
          </div>
          </form>
        </div>
      </div>
    </div>

    {/* signinmodal */}
    <div className="modal fade" id="signinmodal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="signinmodal" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">Sign In </h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form onSubmit={signin}>
          <div className="modal-body">
            <input type="email" name="email" required  placeholder="email"/>  
            <input type="password" name="password" required placeholder="password"  />              
          </div>
          <div className="modal-footer">
            <button type="submit" className="btn btn-danger">Sign In</button>
          </div>
          </form>
        </div>
      </div>
    </div>
    </>
  );
};

export default Navbar;
